export default {"src":"/_next/static/media/heart2_64.ec3d2878.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};